import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawards from '../../subawards'

export const RESOURCE = {
  payload: {
    description:
      'A subaward is a portion of the primary award provided to a subrecipient to support a project, requiring a contract that specifies terms and conditions and includes compliance monitoring activities.',
    dimension: subawards.RESOURCE.payload,
    level: 0,
    name: 'Subaward',
    partialId: PartialId.Standard.create('subaward'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
